import '@vanilla-extract/css/vanilla.virtual.css?ve-css=Ll8xYTg0dzJ1MCB7CiAgbWluLWhlaWdodDogMTAwdmg7Cn0';
export var stackContainerClass = '_1a84w2u0';